import { useState } from "react";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { PageHeader } from "@/components/common/PageHeader";
import { useAuth } from "@/auth/useAuth";
import { BranchesTab } from "./tabs/BranchesTab";
import { SubjectsTab } from "./tabs/SubjectsTab";
import { RoomsTab } from "./tabs/RoomsTab";
import { UsersTab } from "./tabs/UsersTab";
import { RolesMatrixTab } from "./tabs/RolesMatrixTab";
import { IntegrationsTab } from "./tabs/IntegrationsTab";
import { SystemTab } from "./tabs/SystemTab";

export function SettingsPage() {
  const { hasPermission } = useAuth();
  const canCatalog = hasPermission("set.catalog");
  const canUsers = hasPermission("set.users");
  const canRoles = hasPermission("set.roles");
  const canIntegr = hasPermission("set.integr");

  // Структура вкладок в точности соответствует прототипу (proschool-crm_8.html, ST.tab):
  // catalog («Филиалы и кабинеты»), subjects, users, roles, integr, system.
  const tabDefs = [
    { key: "branches", label: "Филиалы и кабинеты", show: canCatalog },
    { key: "subjects", label: "Предметы и цены", show: canCatalog },
    { key: "users", label: "Пользователи системы", show: canUsers },
    { key: "roles", label: "Права доступа", show: canRoles },
    { key: "integrations", label: "Интеграции", show: canIntegr },
    { key: "system", label: "Система", show: canCatalog },
  ].filter((t) => t.show);

  const [activeKey, setActiveKey] = useState(tabDefs[0]?.key ?? "branches");

  return (
    <>
      <PageHeader title="Настройки" subtitle="Справочники, пользователи, права доступа и интеграции" />
      <Paper className="crm-workspace-panel crm-settings" variant="outlined">
        <Tabs value={activeKey} onChange={(_, v) => setActiveKey(v)} variant="scrollable" scrollButtons={false}>
          {tabDefs.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} />
          ))}
        </Tabs>
        <Box className="crm-workspace-panel__body" p={3}>
          {activeKey === "branches" && (
            <Box display="flex" flexDirection="column" gap={4}>
              <BranchesTab />
              <RoomsTab />
            </Box>
          )}
          {activeKey === "subjects" && <SubjectsTab />}
          {activeKey === "users" && <UsersTab />}
          {activeKey === "roles" && <RolesMatrixTab />}
          {activeKey === "integrations" && <IntegrationsTab />}
          {activeKey === "system" && <SystemTab />}
        </Box>
      </Paper>
    </>
  );
}
